import { Link } from 'react-router-dom'
import styled from 'styled-components'

const HeaderDropdown = styled.div`
	background-color: #f1f1f1;
	overflow: auto;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
	font-size: 18px;
	border: solid black 1px;
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	padding: 4px 4px;
`

const HeaderDropdownItem = styled.a`
	color: black;
	padding: 6px 24px;
	text-decoration: none;
	display: block;
	text-align: start;
	width: auto;

	&:hover {
		background-color: lightgrey;
	}
`

const HeaderDropdownItemL = styled(Link)`
	color: black;
	padding: 6px 24px;
	text-decoration: none;
	display: block;
	text-align: start;

	&:hover {
		background-color: lightgrey;
	}
`

export { HeaderDropdown, HeaderDropdownItem, HeaderDropdownItemL }
